module.exports = __webpack_public_path__ + "img/maps-marker-lead.b74bc0fb.svg";